import { render, staticRenderFns } from "./PayDaysFilter.vue?vue&type=template&id=4b124338&"
import script from "./PayDaysFilter.vue?vue&type=script&lang=js&"
export * from "./PayDaysFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports